import React, { Component } from "react";
import RoutedLink from "../RouterLink/RoutedLink";
import "./Sticky.scss";
import { SizeContext } from '../../contexts/resize-context';

const ComponentName = "Sticky"
export class Sticky extends Component {
    static contextType = SizeContext
    constructor(props) {
        super(props);
    }

    renderButton(buttonConfig, logotitle) {
        const styleSystem = this.props?.appliedCssClassNames?.split(' ') || null
        const buttonClass = styleSystem?.filter(v => v.startsWith('button_')).join(' ') || ''
        const { buttonProps, type } = buttonConfig
        return (
            <RoutedLink
                className={`${buttonClass}`}
                to={buttonProps?.url}
                target={buttonProps?.target}
                componentTree={['Sticky', this.props?.sticky?.title]}
                label={buttonProps?.text}
            >
                <i className={logotitle}>
                    <p>{buttonProps?.text}</p>
                </i>

            </RoutedLink>

        )
    }
    

    render() {
        return (
            (this.context?.isTablet || this.context?.isMobile || this.props.isInEditor || this.props.test) ?
                <div className="sticky-container">
                    {(this.props?.sticky?.primaryButton?.url) && (
                        <div className='sicky-button'>
                            {this.props?.sticky?.primaryButton?.url && (
                                this.renderButton({ buttonProps: this.props?.sticky?.primaryButton }, this.props?.sticky?.iconfont)
                            )}
                        </div>
                    )}
                    {(this.props?.sticky?.secondaryButton?.url) && (
                        <div className='sicky-button'>
                            {this.props?.sticky?.secondaryButton?.url && (
                                this.renderButton({ buttonProps: this.props?.sticky?.secondaryButton }, this.props?.sticky?.secondaryiconfont)
                            )}
                        </div>
                    )}
                    {(this.props?.sticky?.terciaryButton?.url) && (
                        <div className='sicky-button'>
                            {this.props?.sticky?.terciaryButton?.url && (
                                this.renderButton({ buttonProps: this.props?.sticky?.terciaryButton }, this.props?.sticky?.terciaryiconfont)
                            )}
                        </div>
                    )}
                    {(this.props?.sticky?.quaternaryButton?.url) && (
                        <div className='sicky-button'>
                            {this.props?.sticky?.quaternaryButton?.url && (
                                this.renderButton({ buttonProps: this.props?.sticky?.quaternaryButton }, this.props?.sticky?.quaternaryiconfont)
                            )}
                        </div>
                    )}
                </div>
                : ""
        )
    }
}

export default Sticky;